import { createFileRoute } from '@tanstack/react-router'

import { Webhooks } from '@/widgets/webhooks'

export const Route = createFileRoute('/_app/webhooks')({
  component: RouteComponent,
})

export const WebhooksRoute = Route

function RouteComponent() {
  return <Webhooks />
}
